<script setup lang="ts">

import { useGameStore } from '@/stores/gameStore.ts'
import Backend from '@/models/backend.ts'
import { computed } from 'vue'
import ToggleSwitch from '@/components/Elements/ToggleSwitch/ToggleSwitch.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps<{
  newsType: string,
  status:string
}>();

/**
 * Stores
 */
const gameStore = useGameStore()

/**
 * function
 */
const toggleNewsItem = () => {
  const backend = new Backend();
  backend.toggleNotificationNewsType(props.newsType).then(() => {
    gameStore.setTinySuccessToastMessage(t('news.notifications.toggled'));
  });
}

const isEnabled = computed(() => props.status === 'enabled')

</script>

<template>
  <div class="flex justify-between items-center ps-2 rounded bg-slate-900 p-1 mb-1">
    <div>{{ t(`news.notificationTypes.${newsType}`) }}</div>
    <div><ToggleSwitch :model-value="isEnabled" @update:model-value="toggleNewsItem" /></div>
  </div>
</template>

<style scoped lang="scss">

</style>